import { useState, useEffect } from 'react'
import { AdminLayout } from '../../components/layouts/Layout'
import { DataTable } from '../../components/common/DataTable'
import { Badge } from '../../components/common/UI'
import { Lock } from 'lucide-react'
import { formatters } from '../../utils/formatting'
import { merchantService, businessService } from '../../services/api'

export default function Merchants() {
  const [merchants, setMerchants] = useState<any[]>([])
  const [businesses, setBusinesses] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    try {
      const [merchantsData, businessesData] = await Promise.all([
        merchantService.list(),
        businessService.list()
      ])
      setMerchants(merchantsData)
      setBusinesses(businessesData)
    } catch (error) {
      console.error('Failed to load data:', error)
    } finally {
      setLoading(false)
    }
  }

  const getBusinessCount = (merchantId: string) => {
    return businesses.filter(b => b.merchantId === merchantId).length
  }

  const toggleStatus = async (merchant: any) => {
    const newStatus = merchant.accountStatus === 'ACTIVE' ? 'SUSPENDED' : 'ACTIVE'
    await merchantService.update(merchant.id, { accountStatus: newStatus })
    await loadData()
  }

  const columns = [
    { key: 'fullName' as const, label: 'Name' },
    { key: 'email' as const, label: 'Email' },
    { 
      key: 'tokenBalance' as const, 
      label: 'Token Balance',
      render: (value: number) => formatters.number(value || 0)
    },
    {
      key: 'totalSpent' as const,
      label: 'Total Spent',
      render: (value: number) => formatters.currency(value || 0)
    },
    {
      key: 'id' as const,
      label: 'Businesses',
      render: (_: any, row: any) => getBusinessCount(row.id)
    },
    {
      key: 'accountStatus' as const,
      label: 'Status',
      render: (value: string) => (
        <Badge variant={value === 'ACTIVE' ? 'success' : 'error'}>
          {value}
        </Badge>
      )
    },
    {
      key: 'createdAt' as const,
      label: 'Joined',
      render: (value: string) => formatters.date(value)
    }
  ]

  const actions = [
    {
      icon: Lock,
      label: 'Toggle Status',
      onClick: toggleStatus,
      variant: 'ghost' as const
    }
  ]

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center min-h-screen">
          <p>Loading...</p>
        </div>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Merchants</h1>
          <p className="text-gray-600">Manage merchant accounts</p>
        </div>

        <DataTable data={merchants} columns={columns} actions={actions} onSearch={() => {}} />
      </div>
    </AdminLayout>
  )
}